import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "basket-popup__container" }
const _hoisted_2 = { class: "basket-popup__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "basket-popup__title" }, "Ваш заказ", -1)
const _hoisted_4 = { class: "basket-popup__navigation" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__navigation-body" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "basket-popup__share" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "basket-popup__close" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "basket-popup__main" }
const _hoisted_9 = { class: "basket-popup__item" }
const _hoisted_10 = { class: "basket-popup__img" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-title" }, " Стейк стриплойн говяжий Black Angus "),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-gramm" }, "460 г • 17 900 ₽ / кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-total" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--remove" }),
      /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-body" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-number" }, "1 шт"),
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-price" }, "10 039 ₽")
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--add" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-prices" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-price" }, "13 900 ₽"),
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-sale" }, "17 900 ₽")
    ])
  ])
], -1)
const _hoisted_13 = { class: "basket-popup__item" }
const _hoisted_14 = { class: "basket-popup__img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-title" }, " Стейк стриплойн говяжий Black Angus "),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-gramm" }, "460 г • 17 900 ₽ / кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-total" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--remove" }),
      /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-body" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-number" }, "1 шт"),
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-price" }, "10 039 ₽")
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--add" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-prices" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-price" }, "13 900 ₽"),
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-sale" }, "17 900 ₽")
    ])
  ])
], -1)
const _hoisted_17 = { class: "basket-popup__item" }
const _hoisted_18 = { class: "basket-popup__img" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-title" }, " Стейк стриплойн говяжий Black Angus "),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-gramm" }, "460 г • 17 900 ₽ / кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-total" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--remove" }),
      /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-body" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-number" }, "1 шт"),
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-price" }, "10 039 ₽")
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--add" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-prices" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-price" }, "13 900 ₽"),
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-sale" }, "17 900 ₽")
    ])
  ])
], -1)
const _hoisted_21 = { class: "basket-popup__item" }
const _hoisted_22 = { class: "basket-popup__img" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-title" }, " Стейк стриплойн говяжий Black Angus "),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-gramm" }, "460 г • 17 900 ₽ / кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-total" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--remove" }),
      /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-body" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-number" }, "1 шт"),
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-price" }, "10 039 ₽")
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--add" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-prices" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-price" }, "13 900 ₽"),
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-sale" }, "17 900 ₽")
    ])
  ])
], -1)
const _hoisted_25 = { class: "basket-popup__item" }
const _hoisted_26 = { class: "basket-popup__img" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-title" }, " Стейк стриплойн говяжий Black Angus "),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-gramm" }, "460 г • 17 900 ₽ / кг"),
  /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-total" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count" }, [
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--remove" }),
      /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-body" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-number" }, "1 шт"),
        /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-count-price" }, "10 039 ₽")
      ]),
      /*#__PURE__*/_createElementVNode("button", { class: "basket-popup__item-count-btn basket-popup__item-count-btn--add" })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__item-prices" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-price" }, "13 900 ₽"),
      /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__item-sale" }, "17 900 ₽")
    ])
  ])
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "basket-popup__calculation" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price-body" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "basket-popup__caption" }, "Товары"),
    /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price" }, "13 900р")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price-body" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "basket-popup__caption" }, "Доставка"),
    /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price" }, "240р")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "basket-popup__caption basket-popup__caption--small" }, " Сегодня: 1 товар "),
    /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price basket-popup__price--small" }, "100")
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "basket-popup__caption basket-popup__caption--small" }, " 16 февраля: 1 товар "),
    /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__price basket-popup__price--small" }, "100")
  ])
], -1)
const _hoisted_30 = { class: "basket-popup__bottom" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__total" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__total-title" }, "Итого"),
  /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__total-price" }, "13 900")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "basket-popup__consent" }, [
  /*#__PURE__*/_createTextVNode("Нажимая на кнопку вы соглашаетесь с "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "##",
    class: "basket-popup__consent basket-popup__consent--link"
  }, "условия обработки персональных данных")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    ref: "openBasket",
    modelValue: _ctx.basketInfo,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.basketInfo) = $event)),
    class: "basket-popup",
    location: "right",
    width: "640",
    color: "#262626",
    temporary: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: "basket-popup__navigation-body",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.basketInfo = false))
            }, _hoisted_7)
          ])
        ]),
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: require('@/assets/img/meat_item_basket.png'),
                alt: "Photo meat"
              }, null, 8, _hoisted_11)
            ]),
            _hoisted_12
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: require('@/assets/img/meat_item_basket.png'),
                alt: "Photo meat"
              }, null, 8, _hoisted_15)
            ]),
            _hoisted_16
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("img", {
                src: require('@/assets/img/meat_item_basket.png'),
                alt: "Photo meat"
              }, null, 8, _hoisted_19)
            ]),
            _hoisted_20
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("img", {
                src: require('@/assets/img/meat_item_basket.png'),
                alt: "Photo meat"
              }, null, 8, _hoisted_23)
            ]),
            _hoisted_24
          ]),
          _createElementVNode("li", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("img", {
                src: require('@/assets/img/meat_item_basket.png'),
                alt: "Photo meat"
              }, null, 8, _hoisted_27)
            ]),
            _hoisted_28
          ])
        ]),
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.isLogin ? _ctx.openPhone() : _ctx.openPay())),
            class: "basket-popup__btn"
          }, "Перейти к оформлению заказа"),
          _hoisted_32
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}